import React, { useRef, useState, useEffect, useCallback } from 'react';
import Cookies from 'js-cookie';
import styles from '../ParceriasIframe/ParceriasIframe.module.css';
import API_BASE_URL from '../../services/config/api';

const ParceriasIframe = ({
	baseUrl = API_BASE_URL,
	onReady,
	onAuthError,
	className = '',
}) => {
	const iframeRef = useRef(null);
	const containerRef = useRef(null);
	const sendTokenRef = useRef(null);
	const lastHeightRef = useRef(null); // ← NOVO: Guarda a última altura aplicada

	const [isReady, setIsReady] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	// 🔐 Pega token
	const userData = Cookies.get('user')
		? JSON.parse(Cookies.get('user'))
		: null;

	const token = userData?.token || null;

	// 🔗 URLs
	const iframeSrc = `${baseUrl}/parcerias/app/`;
	const allowedOrigin = new URL(baseUrl).origin;

	// 🛑 Trava para impedir duplicação
	const tokenSentRef = useRef(false);

	// 📤 Envia o token para o iframe (UMA ÚNICA VEZ)
	const sendToken = useCallback(() => {
		if (token && iframeRef.current?.contentWindow) {
			console.log('[Parent] Enviando token para iframe...');
			iframeRef.current.contentWindow.postMessage(
				{ type: 'SET_AUTH_TOKEN', token },
				allowedOrigin
			);
			tokenSentRef.current = true; // marca como enviado
		}
	}, [token, allowedOrigin]);

	useEffect(() => {
		sendTokenRef.current = sendToken;
	}, [sendToken]);

	const clearToken = useCallback(() => {
		if (iframeRef.current?.contentWindow) {
			iframeRef.current.contentWindow.postMessage(
				{ type: 'CLEAR_AUTH_TOKEN' },
				allowedOrigin
			);
		}
		tokenSentRef.current = false;
	}, [allowedOrigin]);

	// 📩 RECEBIMENTO DE MENSAGENS DO IFRAME
	useEffect(() => {
		const handleMessage = (event) => {
			if (event.origin !== allowedOrigin) return;

			const { type, height, ...data } = event.data || {};

			// ← NOVO: Filtra logs do IFRAME_RESIZE para não poluir console
			if (type !== 'IFRAME_RESIZE') {
				console.log('[Parent] Mensagem recebida:', type);
			}

			switch (type) {
				case 'IFRAME_READY':
					console.log(
						'[Parent] IFRAME_READY recebido, enviando token...'
					);
					if (sendTokenRef.current) {
						sendTokenRef.current();
					}
					setIsLoading(false);
					break;

				case 'AUTH_TOKEN_RECEIVED':
					console.log('[Parent] Token confirmado pelo iframe');
					setIsReady(true);
					setIsLoading(false);
					onReady && onReady();
					break;

				case 'AUTH_ERROR':
					console.error('[Parent] Erro de autenticação:', data);
					onAuthError && onAuthError(data);
					setIsLoading(false);
					break;

				case 'IFRAME_RESIZE':
					// ← MUDANÇA: Só atualiza se a altura realmente mudou
					if (height && lastHeightRef.current !== height) {
						lastHeightRef.current = height;

						if (iframeRef.current) {
							iframeRef.current.style.height = `${height}px`;
						}
						if (containerRef.current) {
							containerRef.current.style.height = `${height}px`;
						}
					}
					break;

				default:
					break;
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, [allowedOrigin, onReady, onAuthError]);

	useEffect(() => {
		if (!token) {
			clearToken();
			setIsReady(false);
		}
	}, [token, clearToken]);

	return (
		<div
			ref={containerRef}
			className={`${styles.container}`}>
			{isLoading && (
				<div className={styles.loadingOverlay}>
					<div className={styles.spinner} />
					<p>Carregando módulo de parcerias...</p>
				</div>
			)}

			<iframe
				ref={iframeRef}
				src={iframeSrc}
				className={styles.iframe}
				title='Gestão de Parcerias'
				scrolling='no'
			/>
		</div>
	);
};

export default ParceriasIframe;
